import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getUserConfig = params => {
  return call(websocketFetch, 'get_user_config', { user_id: params?.userId });
};
